import { DateRenderer, DateTimeRenderer, TimeRenderer } from "../../dateTimeRenderers";
import { TableColumnDef } from "../types";

import styles from "./styles.module.scss";

export function DateTimeColumn<T extends object = {}>(
  { formatAsTime, formatAsDate, ...params }: TableColumnDef<T> & { formatAsTime?: boolean, formatAsDate?: boolean },
): TableColumnDef<T> {
  return {
    enableColumnFilter: false,
    minSize: 50,
    cell: props => {
      const value = props.getValue() as any;

      return (
        <span className={styles.content}>
          {(()=>{
            if (formatAsDate) {
              return <DateRenderer value={value} />
            }
            if (formatAsTime) {
              return <TimeRenderer value={value} />
            }
            return <DateTimeRenderer value={value} />
          })()}
        </span>
      );
    },
    ...params,
    meta: {
      excelProps: {
        //todo implement
        //valueModifier: (value, context) => value
        //   ? // hotfix for displaying dates in user selected time zone (Excel works with UTC by default)
        //   new Date(convertFromServerTime(value, context.serverTimeZone, context.serverDateTimeFormatMoment)
        //     .tz(context.timeZone)
        //     .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z")
        //   : value,
        numFmt: formatAsDate ? "mm/dd/yyyy" : (formatAsTime ? "HH:MM" : "mm/dd/yyyy HH:MM"),
        width: 16,
        filterButton: true,
        ...params?.meta?.excelProps,
      },
    },
  };
}
